import { useState, useEffect } from "react";
import CommonModal from "component/Common/CommonModal";
import { XMarkIcon } from "@heroicons/react/24/outline";
import clevertap from "clevertap-web-sdk";

const CookiesPreferencePopup = ({ show, onClose, onSavePreferences, onAllowAll }) => {
  const [marketingCookies, setMarketingCookies] = useState(true);

  // Reset the toggle to reflect the saved preference each time the popup opens
  useEffect(() => {
    if (show) {
      const savedConsent = localStorage.getItem("cookie-consent");
      setMarketingCookies(savedConsent !== "false");
    }
  }, [show]);

  const handleSave = () => {
    clevertap.privacy.push({ optOut: !marketingCookies });
    onSavePreferences(marketingCookies);
  };

  const handleAllowAll = () => {
    setMarketingCookies(true);
    clevertap.privacy.push({ optOut: false });
    onAllowAll();
  };

  return (
    <CommonModal
      show={show}
      size="md"
      center="true"
      customBodyClass="overflow-hidden rounded-3xl"
      customContentClass="rounded-3xl"
      handleClose={onClose}
    >
      <div className="flex flex-col bg-white rounded-3xl">
        <div className="pl-6 pr-3 py-3 flex items-center justify-between shadow-[0px_-4px_16px_0px_rgba(0,0,0,0.16)]">
          <h2 className="text-sm font-bold">Cookie Preferences</h2>
          <button
            className="flex items-center justify-center w-9 h-9 rounded-full bg-grey-50 hover:bg-grey-100"
            onClick={onClose}
          >
            <XMarkIcon className="w-5 stroke-2" />
          </button>
        </div>

        <div className="px-4 landing-md:px-6 py-6 space-y-4 landing-md:space-y-0">
          <p className="text-xs text-grey-700">
            For more details on how we use cookies, please read our{" "}
            <a href="/cookie-policy" className="underline font-medium text-black-text-color">
              Cookie Policy
            </a>
            .
          </p>
          <div className="flex items-start justify-between py-0 px-0 landing-md:py-3 landing-md:pr-4 gap-4">
            <div className="flex gap-3 landing-md:pl-4">
              <span className="material-symbols-outlined text-grey-700 mt-0.5">cookie</span>
              <div>
                <p className="font-bold text-sm">Strictly Necessary Cookies</p>
                <p className="text-xs landing-md:text-sm text-grey-700 mt-1 max-w-[380px]">
                  These cookies are required for the website to operate correctly and to support
                  basic navigation and features. If they are disabled, requested services will not
                  function as intended.
                </p>
              </div>
            </div>

            <button className="relative inline-flex h-6 w-11 pr-[22px] landing-md:pr-5 items-center rounded-full bg-primary opacity-70 cursor-not-allowed">
              <span className="inline-block h-5 w-5 translate-x-5 rounded-full bg-white" />
            </button>
          </div>

          <div className="flex items-start justify-between py-0 px-0 landing-md:py-3 landing-md:pr-4 gap-4">
            <div className="flex gap-3 landing-md:pl-4">
              <span className="material-symbols-outlined text-grey-700 mt-0.5">cookie</span>
              <div>
                <p className="font-bold text-sm">Marketing Cookies</p>
                <p className="text-xs landing-md:text-sm text-grey-700 mt-1 max-w-[380px]">
                  These cookies are placed on our website by advertising partners to help recognize
                  users and deliver content that is relevant to them.
                </p>
              </div>
            </div>

            <button
              onClick={() => setMarketingCookies(!marketingCookies)}
              className={`relative inline-flex h-6 w-11 pr-[22px] landing-md:pr-5 items-center rounded-full cursor-pointer transition-colors ${marketingCookies ? "bg-primary" : "bg-grey-200"}`}
            >
              <span
                className={`inline-block h-5 w-5 rounded-full bg-white transition-transform ${marketingCookies ? "translate-x-5" : "translate-x-1"}`}
              />
            </button>
          </div>
        </div>

        <div className="px-5 py-3 grid grid-cols-2 gap-3 landing-md:flex landing-md:justify-end shadow-[0px_0px_4px_0px_rgba(0,0,0,0.16)]">
          <button
            className="w-full landing-md:w-auto landing-md:min-w-24 text-xs font-bold bg-grey-50 hover:bg-grey-100 border-card-width border-grey-border py-2 px-4 rounded-4xl"
            onClick={handleAllowAll}
          >
            Allow All
          </button>

          <button
            className="w-full landing-md:w-auto landing-md:min-w-28 text-xs font-bold bg-primary hover:bg-primary-dark py-2 px-4 text-white rounded-4xl"
            onClick={handleSave}
          >
            Save Preferences
          </button>
        </div>
      </div>
    </CommonModal>
  );
};

export default CookiesPreferencePopup;
